import * as React from 'react';
import { memo } from 'react';

const SvgMonitor = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 21H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 16.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5V15h18v1.5Zm-1.5-12A1.5 1.5 0 0 1 21 6v7.5H3V6a1.5 1.5 0 0 1 1.5-1.5h15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 18v3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgMonitor);

export { Memo as default };
